import { noChange } from "lit";
import { AsyncDirective, directive } from "lit/async-directive.js";
import { PartType } from "lit/directive.js";
import { container } from "tsyringe";
import { TitleService } from "../services/title.service";
class HtmlTitleDirective extends AsyncDirective {
    constructor(partInfo) {
        super(partInfo);
        this._showOnClick = false;
        this._isHidden = true;
        this._hasjustShown = false;
        this._noDelay = false;
        if (partInfo.type !== PartType.ELEMENT) {
            throw new Error("The `setitle` directive must be used in an element");
        }
        this._titleService = container.resolve(TitleService);
    }
    update(part, [title, showOnClick, description, maxWidth, noDelay, position]) {
        this._title = title;
        this._description = description;
        this._maxWidth = maxWidth;
        this._showOnClick = showOnClick;
        this._noDelay = noDelay;
        this._position = position;
        //this._titleService.hideTitle();
        //this._isHidden = true;
        if (this._element !== part.element) {
            if (this._element) {
                this._element.removeEventListener("mouseenter", (evt) => this.onMouseEnter(evt));
                this._element.removeEventListener("mouseleave", (evt) => this.onMouseLeave(evt));
                this._element.removeEventListener("mousedown", (evt) => this.onMouseDownAsync(evt));
            }
            this._element = part.element;
            this._element.addEventListener("mouseenter", (evt) => this.onMouseEnter(evt));
            this._element.addEventListener("mouseleave", (evt) => this.onMouseLeave(evt));
            this._element.addEventListener("mousedown", (evt) => this.onMouseDownAsync(evt));
        }
        return this.render(title, showOnClick, description, maxWidth);
    }
    onMouseLeave(evt) {
        evt.stopPropagation();
        this.clearTimer();
        if (!this._isHidden) {
            this._titleService.hideTitle();
            this._isHidden = true;
            this._hasjustShown = false;
        }
    }
    async onMouseDownAsync(evt) {
        evt.stopPropagation();
        if (this._showOnClick && this._isHidden)
            await this.showTitleAsync(true);
        else if (!this._showOnClick || !this._hasjustShown)
            this.onMouseLeave(evt);
    }
    onMouseEnter(evt) {
        evt.stopPropagation();
        if (!this._title &&
            (this._element.clientHeight !== this._element.scrollHeight || this._element.clientWidth !== this._element.scrollWidth))
            this._element.style.cursor = "pointer";
        if (this._noDelay)
            this.showTitleAsync();
        else if (!this._timeout)
            this._timeout = window.setTimeout(() => this.showTitleAsync(), 500);
    }
    clearTimer() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = undefined;
        }
    }
    hasJustShown() {
        this.clearTimer();
        this._hasjustShown = false;
    }
    async showTitleAsync(isClick = false) {
        var _a;
        this.clearTimer();
        if (this._showOnClick && !isClick) {
            this._hasjustShown = true;
            this._timeout = window.setTimeout(() => this.hasJustShown(), 500);
        }
        if (!this._element["active"]) {
            if (this._element.disabled)
                return;
            if (!this._title &&
                this._element.clientHeight === this._element.scrollHeight &&
                this._element.clientWidth === this._element.scrollWidth)
                return;
            await this._titleService.showTitleAsync(this._element, (_a = this._title) !== null && _a !== void 0 ? _a : this._element.textContent, this._description, this._maxWidth, this._noDelay, this._position);
            this._isHidden = false;
        }
    }
    disconnected() {
        this._element.removeEventListener("mouseenter", (evt) => this.onMouseEnter(evt));
        this._element.removeEventListener("mouseleave", (evt) => this.onMouseLeave(evt));
        this._element.removeEventListener("mousedown", (evt) => this.onMouseDownAsync(evt));
    }
    reconnected() {
        if (this._element) {
            this._element.removeEventListener("mouseenter", (evt) => this.onMouseEnter(evt));
            this._element.removeEventListener("mouseleave", (evt) => this.onMouseLeave(evt));
            this._element.removeEventListener("mousedown", (evt) => this.onMouseDownAsync(evt));
            this._element.addEventListener("mouseenter", (evt) => this.onMouseEnter(evt));
            this._element.addEventListener("mouseleave", (evt) => this.onMouseLeave(evt));
            this._element.addEventListener("mousedown", (evt) => this.onMouseDownAsync(evt));
            this._isHidden = true;
        }
    }
    render(title, showOnClick, description, maxWidth, noDelay, position) {
        return noChange;
    }
}
export const htmlTitle = directive(HtmlTitleDirective);
//# sourceMappingURL=html-title.directive.js.map